<template>
    <div v-if="config.display" :style="{'width': config.width}" class="control e-control">
        <div v-if="asField">
            <display-value :id="config.id" :value="value"></display-value>
        </div>
        <div v-else-if="!initialLoad">
            <YouTube
                v-bind="syncfusionConfig"
                :src="value"
                :data-test-id="dataTestId"
                @ready="onReady(); action($event, 'onready')"
                @state-change="stateChange($event);  action($event, 'onstatechange')"
                :ref="ref"
            />
            <p v-if="config.description" class="youtube-custom-message">{{config.description}}</p>
        </div>
    </div>
</template>

<script>
import { controlMixins } from "./controlMixins.js";
// eslint-disable-next-line import/no-extraneous-dependencies
import YouTube from 'vue3-youtube';
import { library } from "@common/library/library";

/*
* Please check following links for get available params and functions of the YouTube player
* https://developers.google.com/youtube/iframe_api_reference
* https://developers.google.com/youtube/player_parameters
* */

export const youtubeComponent = {
    mixins: [controlMixins],
    data: function () {
        return {
            lastPlayTime: 0,
            lastPlayTimeTimeout: false,
            fastForwardDetected: false,
            initialLoad: true
        };
    },
    mounted() {
        let tmpElement = document.getElementById('youtube-iframe-js-api-script');
        if (!tmpElement) {
            let ytScript = document.createElement('script');
            ytScript.setAttribute('src', "https://www.youtube.com/iframe_api");
            ytScript.setAttribute('id', 'youtube-iframe-js-api-script');
            ytScript.onload = () => {
                if (typeof YT !== 'undefined' && !YT.loaded) {
                    YT.ready(() => {
                        this.initialLoad = false;
                    });
                } else {
                    this.initialLoad = false;
                }
            };
            document.head.appendChild(ytScript);
        } else {
            this.initialLoad = false;
        }
    },
    computed: {
        ref() {
            return this.config.ref || this.config.id;
        }
    },
    methods: {
        stateChange(event) {
            if (typeof YT !== 'undefined' && this.$refs && this.$refs[this.ref] && this.$refs[this.ref].player) {
                if (this.config && this.config.disableFastForward) {
                    if (event.data === YT.PlayerState.PLAYING) {
                        if (this.$refs[this.ref].player.getCurrentTime() - this.lastPlayTime > 1) {
                            // if (this.lastPlayTimeTimeout) clearTimeout(this.lastPlayTimeTimeout);
                            let lastPlayTime = this.lastPlayTime;
                            this.fastForwardDetected = true;
                            this.$refs[this.ref].player.pauseVideo();
                            library.showDialog(
                                "You must watch the entire video. Please do not fast-forward. Please go back to the last place in the video that you watched.",
                                () => {
                                    this.fastForwardDetected = false;
                                    this.$refs[this.ref].player.seekTo(lastPlayTime);
                                    this.$refs[this.ref].player.playVideo();
                                },
                                false,
                                {
                                    title: 'Video Watch Notice',
                                    okButtonLabel: 'Go Back',
                                    showAsAlert: true
                                }
                            );
                        }
                    }
                    if (event.data === YT.PlayerState.PAUSED && !this.fastForwardDetected) {
                        this.lastPlayTimeTimeout = setTimeout(() => {
                            this.lastPlayTime = this.$refs[this.ref].player.getCurrentTime();
                            library.setLocalStorage('lastPlayTime' + this.value, this.lastPlayTime);
                        }, 300);
                    }
                }
                if (event.data === YT.PlayerState.ENDED) {
                    library.removeLocalStorage('lastPlayTime' + this.value);
                    this.action(event, 'oncomplete');
                }
            }
        },
        onReady() {
            if (
                this.config
                && this.config.allowResume
                && library.getLocalStorage('lastPlayTime' + this.value)
                && this.$refs
                && this.$refs[this.ref]
                && this.$refs[this.ref].player
            ) {
                library.showDialog(
                    "This video has been partially watched. Would you like to resume the video from where you left off?",
                    () => {
                        this.lastPlayTime = library.getLocalStorage('lastPlayTime' + this.value);
                        this.$refs[this.ref].player.seekTo(library.getLocalStorage('lastPlayTime' + this.value));
                    },
                    false,
                    {
                        title: 'Resume Video?',
                        okButtonLabel: 'Resume',
                        cancelButtonLabel: 'Start Over'
                    }
                );
            }
        }
    },
    components: {
        YouTube: YouTube,
    }
};

export default youtubeComponent;
</script>

<style scoped>
:deep(.youtube-custom-message) {
    text-align: center;
}
</style>
